import mock from '../mock';

const PickListData = [{
  id: 1,
  color: 'secondary',
  title:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
  datef: '2020-06-03T23:28:56.782Z',
  deleted: false,
},
{
  id: 2,
  color: 'error',
  title:
    'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit,',
  datef: '2020-06-02T23:28:56.782Z',
  deleted: false,
},
{
  id: 3,
  color: 'warning',
  title:
    'consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur?',
  datef: '2020-06-01T23:28:56.782Z',
  deleted: false,
},
{
  id: 4,
  color: 'success',
  title:
    'Adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur?',
  datef: '2020-06-01T23:28:56.782Z',
  deleted: false,
}]
mock.onGet('/api/data/pickList/pickListData').reply(() => [200, PickListData]);
export default PickListData;
